import { inject, Injectable } from '@angular/core';
import { AxiosHttpService } from './axios-http.service';
import { ApiResponse } from '../interfaces/api-response.model';
import {
  ModifyNameDialogModel,
  ModifyNameResponse,
} from '../interfaces/dialogs/modify-name-dialog.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * 會員中心修改姓名dialog service
 */
@Injectable({
  providedIn: 'root',
})
export class ModifyNameDialogService {
  axiosHttpService: AxiosHttpService = inject(AxiosHttpService);
  http: HttpClient = inject(HttpClient);

  /**
   * 修改姓名
   * @param request 修改姓名請求參數
   */
  modifyName(
    request: ModifyNameDialogModel
  ): Observable<ApiResponse<ModifyNameResponse>> {
    return this.http.patch<ApiResponse<ModifyNameResponse>>(
      API_ENDPOINTS.MODIFY_NAME,
      request
    );
  }
}
